import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, InstagramIcon } from 'lucide-react';
interface ToolPreview {
  image: string;
  alt: string;
}
const TOOL_PREVIEWS: ToolPreview[] = [{
  image: 'https://cdn.magicpatterns.com/uploads/gECytNEjPTm8UHCxvqLWhV/Screenshot_2026-07-20_at_2.16.36_AM.png',
  alt: 'Vista previa de la guía de variaciones en wall balls de HYROX Definitivo 360'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/kwUK81jundhgNTLuCAwP1J/Screenshot_2026-07-20_at_2.17.01_AM.png',
  alt: 'Vista previa del sistema de heats paralelos de HYROX Definitivo 360'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/ngc3eV7QHa8Cmxt769G77q/Screenshot_2026-07-20_at_2.17.19_AM.png',
  alt: 'Vista previa de señales de alerta para intervención inmediata'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/gdykXqoESzNYPUFY5YRXHx/Screenshot_2026-07-20_at_2.17.32_AM.png',
  alt: 'Vista previa de la guía de compensaciones en sentadilla'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/2y7PSBaVQSQmaxUF96tTof/Screenshot_2026-07-20_at_2.17.52_AM.png',
  alt: 'Vista previa de los criterios de derivación planificada'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/dcPU4CVGzi6xFPGPabKr6B/Screenshot_2026-07-20_at_2.18.35_AM.png',
  alt: 'Vista previa de una sesión técnica de SkiErg y transiciones'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/crnLspqGy33HES8HLR7eN9/Screenshot_2026-07-20_at_2.18.50_AM.png',
  alt: 'Vista previa de una sesión de fuerza enfocada al tren inferior'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/gJzcnDgu1Bp7tbggYUhjau/Screenshot_2026-07-20_at_2.19.22_AM.png',
  alt: 'Vista previa del macrociclo de 12 semanas para perfil principiante'
}];
export function ToolPreviewCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const shouldReduceMotion = useReducedMotion();
  const activePreview = TOOL_PREVIEWS[activeIndex];
  function goTo(index: number, nextDirection: number) {
    setDirection(nextDirection);
    setActiveIndex((index + TOOL_PREVIEWS.length) % TOOL_PREVIEWS.length);
  }
  function showPrevious() {
    goTo(activeIndex - 1, -1);
  }
  function showNext() {
    goTo(activeIndex + 1, 1);
  }
  return <section className="px-5 py-10" data-id="element-235" data-mp="1unmsb57wrzmf">
      <div className="mx-auto max-w-md" data-id="element-236" data-mp="1qnm3qrr3i81n">
        <h2 className="text-center font-anton text-2xl leading-tight text-white sm:text-3xl" data-id="element-237" data-mp="1qondmswdkohs">
          Echale un vistazo a tu proxima herramienta
        </h2>
        <p className="mt-2 text-center text-sm text-neutral-400" data-id="element-238" data-mp="1gqhgeolik6j9">
          Desliza y mira una pequeña parte de lo que tendrás a mano en cada sesión.
        </p>

        <div className="mt-6 overflow-hidden rounded-2xl border border-white/10 bg-[#111]/95 shadow-xl" role="region" aria-roledescription="carrusel" aria-label="Vistas previas de HYROX Definitivo 360" data-id="element-239" data-mp="a7t0aacxoeam">
          <div className="flex items-center gap-3 border-b border-white/10 px-4 py-3" data-id="element-240" data-mp="70ech8t9lm2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#F5C518]/50 bg-[#F5C518]/10 font-oswald text-xs font-700 text-[#F5C518]" data-id="element-241" data-mp="54s3x4lzgvn3">
              H360
            </span>
            <div className="min-w-0 flex-1" data-id="element-242" data-mp="dwbydejl8jc9">
              <p className="text-[13px] font-700 text-white" data-id="element-243" data-mp="dzq0qms94sjp">HYROX Definitivo 360</p>
              <p className="text-[11px] text-neutral-400" data-id="element-244" data-mp="iulvhuovhu0i">Vista previa del contenido</p>
            </div>
            <InstagramIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-245" data-mp="ntglbgl9ciu4" />
          </div>

          <div className="relative h-[460px] overflow-hidden bg-[#1b1b1b] sm:h-[500px]" data-id="element-246" data-mp="stusyxiy5qrm">
            <AnimatePresence initial={false} mode="wait" custom={direction} data-id="element-247" data-mp="2pohbkhiio6tt">
              <motion.figure key={activePreview.image} custom={direction} initial={shouldReduceMotion ? false : {
              opacity: 0,
              x: direction > 0 ? 36 : -36
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={shouldReduceMotion ? undefined : {
              opacity: 0,
              x: direction > 0 ? -36 : 36
            }} transition={{
              duration: 0.25,
              ease: [0.25, 1, 0.5, 1]
            }} drag={shouldReduceMotion ? false : 'x'} dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={0.16} onDragEnd={(_, info) => {
              if (info.offset.x < -55 || info.velocity.x < -450) showNext();
              if (info.offset.x > 55 || info.velocity.x > 450) showPrevious();
            }} className="absolute inset-0 flex cursor-grab items-center justify-center px-3 py-3 active:cursor-grabbing" data-id="element-248" data-mp="2un0yol8ujonr">
                <img src={activePreview.image} alt={activePreview.alt} className="h-full w-full select-none rounded-lg border border-white/10 object-contain shadow-2xl" draggable={false} data-id="element-249" data-mp="1t78nw59sbjv7" />
              </motion.figure>
            </AnimatePresence>
          </div>

          <div className="flex items-center justify-between border-t border-white/10 px-4 py-3" data-id="element-250" data-mp="1p3ssfc9gbpk3">
            <button type="button" onClick={showPrevious} aria-label="Ver imagen anterior" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:border-[#F5C518] hover:text-[#F5C518] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F5C518]" data-id="element-251" data-mp="2ctddq1t2uywj">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-252" data-mp="rk7ve201gcpy" />
            </button>

            <div className="flex items-center gap-1.5" aria-label={`Imagen ${activeIndex + 1} de ${TOOL_PREVIEWS.length}`} data-id="element-253" data-mp="wf5417teok2b">
              {TOOL_PREVIEWS.map((preview, index) => <button key={preview.image} type="button" onClick={() => goTo(index, index > activeIndex ? 1 : -1)} aria-label={`Ver imagen ${index + 1}`} aria-current={index === activeIndex ? 'true' : undefined} className={`h-2 rounded-full transition-[width,background-color] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F5C518] focus-visible:ring-offset-2 focus-visible:ring-offset-[#111] ${index === activeIndex ? 'w-5 bg-[#F5C518]' : 'w-2 bg-white/25'}`} data-id="element-254" data-mp="8e1s0dvssgtn" data-mpi={index} />)}
            </div>

            <button type="button" onClick={showNext} aria-label="Ver siguiente imagen" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:border-[#F5C518] hover:text-[#F5C518] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F5C518]" data-id="element-255" data-mp="1f1git7hcfjjq">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-256" data-mp="1rcpz5d4c7bev" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}